import { LANGUAGE_DEFINITIONS, SUPPORTED_LANGUAGES } from "@/internals/constants/language";
import type { LanguageCode } from "@/types/languages";

import type { LanguageOption } from "./types";

export const LANGUAGE_SELECTOR_DATA_QA = "language-selector";

// WE BUilt language options from the LANGUAGE_DEFINITIONS constant, that it will be our source of truth for the languages
const buildLanguageOption = (code: LanguageCode): LanguageOption => {
  const definition = LANGUAGE_DEFINITIONS[code];

  return {
    code,
    nativeLabel: definition.nativeLabel,
    label: definition.nativeLabel,
    value: definition.code,
    displayLabel: definition.nativeLabel,
  };
};

export const DEFAULT_LANGUAGE_OPTIONS: LanguageOption[] = SUPPORTED_LANGUAGES.map((code) =>
  buildLanguageOption(code)
);
